import Component from './setting_group.vue'
export default Component
